/**
 * Ajax Forms
 * ======================================
 * - optinal css styles
 * - form validation handled via html5 required attribute
 * - handled with ajax/forms.php
 * - required [hidden] attribute css support
 */

const ELEMENTS = '.ajaxForm'
const SUCCESS_CLASS = 'is-send'
const HIDE_AFTER_SUBMIT = false
const SPAM_PROTECTION = false

class AjaxForm {
	constructor() {
		this.elements = document.querySelectorAll(ELEMENTS)
		this.ajaxUrl = '/app/themes/ipress/ajax/forms.php'

		this.elements.forEach(el => {
			el.addEventListener('submit', this.submitHandler)
		})
	}

	submitHandler = e => {
		e.preventDefault()

		if (SPAM_PROTECTION && !this.spamProtection(e.target)) {
			location.reload()

			return false
		}

		this.ajaxHandler(e.target)
	}

	spamProtection = form => {
		const formData = new FormData(form)

		if (formData.getAll('website')[0].length) {
			return false
		}

		return true
	}

	ajaxHandler = form => {
		const formData = new FormData(form)

		const parent = form.closest('.ajaxForm__parent')
		const body = parent.querySelector('.ajaxForm__body')
		const message = parent.querySelector('.ajaxForm__message')
		const message_success = parent.querySelector('.ajaxForm-success')
		const message_error = parent.querySelector('.ajaxForm-error')
		const submit = form.querySelector('button[type=submit]')

    const questions = form.querySelectorAll('.app-review__questions textarea')

    if(questions){
      questions.forEach(question => {
        if(question.value){
          question.setAttribute('disabled', 'disabled')
          question.setAttribute('readonly', 'readonly')
        }
      });
    }

		submit.classList.add('is-loading')

		const xhr = new XMLHttpRequest()
		xhr.open('POST', this.ajaxUrl, true)
		xhr.send(formData)

		xhr.onreadystatechange = function() {
			if (xhr.readyState === 4) {
				if (HIDE_AFTER_SUBMIT) {
					body.style.display = 'none'
				}

				// ok
				if (xhr.status === 200) {
					// message_success.removeAttribute('hidden')
          submit.querySelector('span').innerHTML = 'Uloženo'
					submit.classList.add('disabled')
					submit.classList.remove('is-loading')
          
          // Reload page after submit to sort the posts by score 
          location.reload()
          /*
          if(submit.getAttribute('id') == 'AppReviewLock') {
            location.reload();
          }*/

          if(parent.closest('.app-entry-card')){
            parent.closest('.app-entry-card').classList.remove('is-wip')
            parent.closest('.app-entry-card').classList.add('is-saved')

            // enable lock?
            const wip = document.querySelector('#AppReview .app-entry-card.is-wip')

            if(!wip) {
              document.querySelector('#AppReviewLock').removeAttribute('disabled')

              if(!localStorage.getItem("lock-notification")){
                alert('Máte ohodnocené všechny projekty. Nyní můžete uzamknout hodnocení!')
              }

              localStorage.setItem("lock-notification", true);
            }
          }
				}
				// error
				else {
          message.removeAttribute('hidden')
					message_error.removeAttribute('hidden')
					console.log('ajaxForm error!', xhr)
				}
			} 
		}
	}
}

new AjaxForm()
